// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec33d2c2","622":"929af364","977":"c9e1ef4e"}[chunkId] + ".chunk.js";
};